var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8049 0.861888C8.54455 0.601539 8.12244 0.601539 7.86209 0.861888L0.528758 8.19522C0.403734 8.32025 0.333496 8.48981 0.333496 8.66663V11.3333C0.333496 11.7015 0.631973 12 1.00016 12H3.66683C3.84364 12 4.01321 11.9297 4.13823 11.8047L11.4716 4.47136C11.7319 4.21101 11.7319 3.7889 11.4716 3.52855L8.8049 0.861888ZM1.66683 10.6666V8.94277L8.3335 2.2761L10.0574 3.99996L3.39069 10.6666H1.66683ZM13.0002 14H1.00016C0.631973 14 0.333496 14.2984 0.333496 14.6666C0.333496 15.0348 0.631973 15.3333 1.00016 15.3333H13.0002C13.3684 15.3333 13.6668 15.0348 13.6668 14.6666C13.6668 14.2984 13.3684 14 13.0002 14Z",
    fill: "#FB7B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.bc7153666b398141b48c2476dcbe31f0.svg";
export { ForwardRef as ReactComponent };